module.exports = __webpack_public_path__ + "img/iPhones-2x.44df60db.png";